export const chartColors = [
    '#546AAA',
    '#388968',
    '#A65A88',
    '#8884d8',
    '#F0BA61',
    '#DFACD2',
    '#A9C4E5',
    '#F49C43',
    '#BA7FB8',
    '#AD7E4B',
    '#A1A3A6',
    '#80BCF7',
    '#A3B4CC',
    '#98D9D9',
    '#A6A4EA',
    '#F17D7C',
    '#F66F8E',
    '#D676A8',
    '#AEAE63',
    '#6BB2AE',
    '#B47C58',
    '#A2A2A0',
    '#806761',
    '#8092D3',
    '#D98D8D',
    '#CE8AE5',
    '#60C0F0',
    '#7ACCA0',
    '#DEA444',
    '#E5B27E',
    '#E0CC86',
    '#63A6E8',
    '#6E91C6',
    '#6CCACA',
    '#7F7BD7',
    '#B97272',
    '#7188DA',
    '#D77A7A',
    '#C57BDF',
    '#CF965D',
    '#C8B161'
];
